module.exports = __webpack_public_path__ + "img/milestone-active.10b6efb4.png";